import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl, IntlShape } from 'react-intl';
import { isEmpty, get, last } from 'lodash';

import { translate } from 'helpers/intl';
import ContainerTabs from 'components/ContainerTabs';
import Breadcrumbs from 'components/Breadcrumbs';
import {
  StyledMediumSectionHeader,
  StyledCaptions,
} from 'containers/AmcDetailsPage/styles';
import {
  getAmcDetailsPageBreadcrumbsPathSelector,
  getAmcDetailsPageSelectedTabValue,
  getAMCFaqSelector,
} from 'store/global/selectors';
import { breadcrumbsItemType } from 'store/global/types';
import { setAMCDetailsPageBreadcrumbsPath, getFaq } from 'store/global/actions';
import messages from 'containers/AmcDetailsPage/messages';
import FrequentlyAskedQuestions from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions';
import MyContractAndGarantiesTab from 'containers/AmcDetailsPage/MyContractAndGarantiesTab';
import ServicesBloc from 'containers/AmcDetailsPage/ServicesBlock';
import MyRefundsTab from 'containers/AmcDetailsPage/MyRefundsTab';
import FollowUpMyRequestsTab from 'containers/AmcDetailsPage/FollowUpMyRequestsTab';
import MyOffers from 'containers/AmcDetailsPage/MyOffers';
import DetailPageLayout from 'components/DetailPageLayout';
import HeaderImage from 'images/AMC-details-background.jpg';
import { StyledShortBody } from 'containers/AUTODashboard/Body/FrequentlyAskedQuestions/styles';
import { sanlamDarkBlue } from 'Material-UI/colors';
import { getRolesUserSelector } from 'store/user/selectors';
import PAGES from 'routes/pages';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import { getRefundsAMC, getRefundAMCDetails } from 'store/sinistre/actions';
import { getContractsAMC } from 'store/contract/actions';
import {
  getContractAMCSelector,
  getBeneficiariesSelector,
} from 'store/contract/selectors';
import {
  getAllRefundsAMCSelector,
  getIsRefundsLoadingSelector,
  getRefundAMCDetailsSelector,
} from 'store/sinistre/selectors';
import { StoreContext } from 'utils/contextStore';
import { getOrganismesApi } from 'store/user/apis';
import { apiOrganismesPAC } from 'store/pac/apis';
import PacRequestsTab from './PacRequestsTab';
import PracticalDataBlock from './PracticalDataBlock';

const AmcDetailsPage = (props: {
  detailsPageBreadcrumbsPath: breadcrumbsItemType[];
  setAMCDetailsPageBreadcrumbsPath: Function;
  intl: IntlShape;
  selectedTabValue: number;
  getFaq: Function;
  faqAMC: [];
  getRefundsAMC: Function;
  getContractsAMC: Function;
  getRefundAMCDetails: Function;
  refunds: any;
  refundDetails: any;
  contracts: any;
  beneficiaries: any;
  isRefundsLoading: boolean;
}) => {
  const [items, setItems] = React.useState<any[]>([]);
  const { organismeListState, organismeListPacState } = React.useContext(
    StoreContext,
  );

  const getOrganismeList = organismeListState?.organismeList;
  const organismeListPac = organismeListPacState?.organismeListPac;

  const hasPac = organismeListPac?.length > 0;
  const hasDM = getOrganismeList?.length > 0;

  const setOrganismeList = organismeListState?.setOrganismeList;
  const setOrganismeListPac = organismeListPacState?.setOrganismeListPac;

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    getOrganismesApi()
      .then((result) => {
        const dmoOrganisme: any[] = [];
        /* istanbul ignore next */
        if (result.data.data.length > 0) {
          props.contracts.map(
            /* istanbul ignore next */ (c: any) => {
              const organisme = result.data.data.find(
                /* istanbul ignore next */ (r: any) =>
                  r.NUM_POLICE === c.NUM_POLICE,
              );
              organisme && dmoOrganisme.push(organisme);
              return null;
            },
          );
        }
        /* istanbul ignore next */
        setOrganismeList(dmoOrganisme);
      })
      .catch((error) => {});

    apiOrganismesPAC({ token })
      .then((result) => {
        const pacOrganisme: any[] = [];
        /* istanbul ignore next */
        if (result.data.data.length > 0) {
          props.contracts.map(
            /* istanbul ignore next */ (c: any) => {
              const organisme = result.data.data.find(
                /* istanbul ignore next */ (r: any) =>
                  r.NUM_POLICE === c.NUM_POLICE &&
                  r.NATURE_POLICE !== 'DIM' &&
                  r.NATURE_POLICE !== 'CNSS',
              );
              organisme && pacOrganisme.push(organisme);
              return null;
            },
          );
        }
        /* istanbul ignore next */
        setOrganismeListPac(pacOrganisme);
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    const suiviDesDemandesItem = {
      label: 'suiviDesDemandes',
      content: <FollowUpMyRequestsTab getOrganismeList={getOrganismeList} />,
    };

    const mesRemboursementsItem = {
      label: 'mesRemboursements',
      content: (
        <MyRefundsTab
          refunds={props.refunds}
          refundDetails={props.refundDetails}
          getRefundAMCDetails={props.getRefundAMCDetails}
          beneficiaries={props.beneficiaries}
          isRefundsLoading={props.isRefundsLoading}
        />
      ),
    };

    const adhesionItem = {
      label: 'adhesion',
      content: (
        <MyContractAndGarantiesTab
          beneficiaries={props.beneficiaries}
          contracts={props.contracts}
          selectedPolice={
            props.detailsPageBreadcrumbsPath.find((p) => p.name === 'adhesion')
              ?.police
          }
        />
      ),
    };

    const suiviPACItem = {
      label: 'suiviPAC',
      content: <PacRequestsTab pacOrganismes={organismeListPac} />,
    };
    /* istanbul ignore next */
    if (hasPac && hasDM) {
      setItems([
        adhesionItem,
        mesRemboursementsItem,
        suiviPACItem,
        suiviDesDemandesItem,
      ]);
    } else if (hasPac) {
      setItems([adhesionItem, mesRemboursementsItem, suiviPACItem]);
    } else if (hasDM) {
      setItems([adhesionItem, mesRemboursementsItem, suiviDesDemandesItem]);
    } else {
      setItems([adhesionItem, mesRemboursementsItem]);
    }
  }, [getOrganismeList, organismeListPac]);

  const language = useSelector(getLocaleSelector);

  useEffect(() => {
    isEmpty(props.contracts) && props.getContractsAMC();
    isEmpty(props.refunds) && props.getRefundsAMC({});
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    props.getFaq(language);
    // eslint-disable-next-line
  }, [language]);

  /* istanbul ignore next */
  const HeaderTextBloc = (
    <>
      <StyledMediumSectionHeader>
        {translate(get(messages, 'title'), props)}
      </StyledMediumSectionHeader>
      <StyledCaptions>
        {translate(get(messages, 'subTitle'), props)}
      </StyledCaptions>
    </>
  );

  return (
    <DetailPageLayout
      headerImage={HeaderImage}
      HeaderTextBloc={HeaderTextBloc}
      Breadcrumbs={
        <Breadcrumbs
          path={props.detailsPageBreadcrumbsPath}
          setBreadcrumbsPath={props.setAMCDetailsPageBreadcrumbsPath}
        />
      }
      TabsBloc={
        <ContainerTabs
          tabItems={items}
          setBreadcrumbsPath={props.setAMCDetailsPageBreadcrumbsPath}
          rootPath={[{ name: 'amc', route: PAGES.AMC_DASHBOARD }]}
          selectedTabValue={
            hasDM &&
            !hasPac &&
            get(last(props.detailsPageBreadcrumbsPath), 'name') ===
              'suiviDesDemandes'
              ? props.selectedTabValue - 1
              : props.selectedTabValue
          }
        />
      }
      FAQBloc={
        <FrequentlyAskedQuestions
          items={
            props.faqAMC &&
            props.faqAMC.map(
              /* istanbul ignore next */ (
                item: { question: string; code: string; id: number },
                index: number,
              ) => ({
                title: (
                  <StyledShortBody
                    weight="bold"
                    color={sanlamDarkBlue}
                    key={index}
                  >
                    {item.question}
                  </StyledShortBody>
                ),
                path: PAGES.FAQ,
                id: item.id,
                code: item.code,
                isFaq: true,
              }),
            )
          }
          GACategoryAllResponses={EVENT_CATEGORIES.AMC_DETAILS}
        />
      }
      PracticalDataBloc={<PracticalDataBlock />}
      ServiceBloc={<ServicesBloc />}
      MyOffersBloc={<MyOffers />}
    />
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    detailsPageBreadcrumbsPath: breadcrumbsItemType[];
    roles: any;
    selectedTabValue: number;
    faqAMC: [];
    refunds: [];
    refundDetails: {};
    contracts: [];
    beneficiaries: [];
    isRefundsLoading: boolean;
  }
>({
  roles: getRolesUserSelector,
  detailsPageBreadcrumbsPath: getAmcDetailsPageBreadcrumbsPathSelector,
  selectedTabValue: getAmcDetailsPageSelectedTabValue,
  faqAMC: getAMCFaqSelector,
  refunds: getAllRefundsAMCSelector,
  isRefundsLoading: getIsRefundsLoadingSelector,
  refundDetails: getRefundAMCDetailsSelector,
  contracts: getContractAMCSelector,
  beneficiaries: getBeneficiariesSelector,
});
const mapDispatchToProps = {
  setAMCDetailsPageBreadcrumbsPath,
  getFaq,
  getRefundsAMC,
  getContractsAMC,
  getRefundAMCDetails,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AmcDetailsPage));
export { AmcDetailsPage as AmcDetailsPageTest };
